import { validUsername } from '@vm/content';

/** Kid-safe generated call signs for restricted accounts ("BraveOtter42"). */
const ADJ = [
  'Brave', 'Swift', 'Mighty', 'Clever', 'Lucky', 'Bold', 'Rapid', 'Sneaky', 'Jolly', 'Cosmic', 'Turbo', 'Epic', 'Blocky', 'Pixel',
  'Shiny', 'Frosty', 'Sunny', 'Stormy', 'Rusty', 'Golden', 'Silver', 'Nimble', 'Zippy', 'Mega', 'Hyper', 'Noble', 'Steady', 'Wild',
  'Chill', 'Fuzzy', 'Atomic', 'Laser', 'Rocket', 'Thunder', 'Crystal', 'Neon', 'Brick', 'Voxel', 'Stealthy', 'Speedy',
];
const NOUN = [
  'Otter', 'Falcon', 'Panda', 'Tiger', 'Badger', 'Fox', 'Rhino', 'Koala', 'Walrus', 'Lynx', 'Hawk', 'Moose', 'Gecko', 'Beaver',
  'Comet', 'Robot', 'Knight', 'Ranger', 'Pilot', 'Builder', 'Scout', 'Wizard', 'Captain', 'Cadet', 'Marine', 'Rocket', 'Dragon',
  'Yeti', 'Narwhal', 'Penguin', 'Turtle', 'Raccoon', 'Squid', 'Puffin', 'Bison', 'Cobra', 'Mammoth', 'Phoenix', 'Golem', 'Titan',
];

export function generateName(): string {
  for (let i = 0; i < 20; i++) {
    const a = ADJ[Math.floor(Math.random() * ADJ.length)];
    const n = NOUN[Math.floor(Math.random() * NOUN.length)];
    const num = Math.floor(Math.random() * 90 + 10);
    const name = `${a}${n}${num}`;
    if (name.length <= 16 && validUsername(name)) return name;
  }
  return `Marine${Math.floor(Math.random() * 9000 + 1000)}`;
}

/** Returns a player-facing problem with a typed name, or null when it is fine. */
export function nameProblem(name: string): string | null {
  const n = name.trim();
  if (n.length < 3) return 'Names need at least 3 characters.';
  if (n.length > 16) return 'Names can be at most 16 characters.';
  if (!/^[A-Za-z0-9_]+$/.test(n)) return 'Use only letters, numbers and underscores.';
  if (!validUsername(n)) return "That name isn't allowed. Try another one.";
  return null;
}
